// src/components/Chat.js
import React, { useState } from 'react';
import { 
  MessageCircle, 
  Hash 
} from 'lucide-react';
import { signInWithPopup } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, googleProvider, db } from '../firebase';
import './Chat.css';

const Chat = ({ 
  user, 
  userProfile, 
  setIsNicknameSetupOpen, 
  openChatWindow 
}) => {
  const [authLoading, setAuthLoading] = useState(false);

  const chatChannels = [
    {
      id: 'general',
      name: '#일반',
      description: '일반적인 대화와 인사',
      color: 'blue'
    },
    {
      id: 'dev',
      name: '#개발',
      description: '기술 토론과 개발 질문',
      color: 'green'
    },
    {
      id: 'trading',
      name: '#트레이딩',
      description: '투자와 거래 정보 공유',
      color: 'purple'
    }
  ];

  // 구글 로그인
  const handleGoogleLogin = async () => {
    setAuthLoading(true);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      // 기존 사용자 프로필 확인
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      
      if (!userDoc.exists()) {
        // 새 사용자인 경우 닉네임 설정 팝업 열기
        setIsNicknameSetupOpen(true);
      }
    } catch (error) {
      console.error('로그인 오류:', error);
      alert('로그인 중 오류가 발생했습니다.');
    } finally {
      setAuthLoading(false);
    }
  };

  // 채팅 열기 (로그인 및 닉네임 확인)
  const handleChatClick = () => {
    if (!user) {
      handleGoogleLogin();
      return;
    }

    if (!userProfile?.nickname) {
      setIsNicknameSetupOpen(true);
      return;
    }

    // 새 창에서 채팅 열기
    openChatWindow();
  };

  return (
    <div className="chat-page">
      <div className="chat-header">
        <h2 className="chat-title">실시간 채팅</h2>
        <p className="chat-subtitle">커뮤니티 멤버들과 실시간으로 소통하세요</p>
      </div>
      
      <div className="chat-content">
        <div className="chat-channels">
          {chatChannels.map((channel) => (
            <div key={channel.id} className={`chat-channel ${channel.color}`}>
              <Hash className="channel-icon" />
              <h3 className="channel-name">{channel.name}</h3>
              <p className="channel-description">{channel.description}</p>
            </div>
          ))}
        </div>
        
        <div className="chat-action">
          <p className="chat-action-text">
            {!user ? '구글 계정으로 로그인하여 채팅에 참여하세요!' : 
             !userProfile?.nickname ? '닉네임을 설정하고 채팅을 시작하세요!' :
             '실시간 채팅에 참여하세요!'}
          </p>
          <button 
            onClick={handleChatClick}
            disabled={authLoading}
            className="chat-start-btn"
          >
            <MessageCircle className="btn-icon" />
            <span>
              {authLoading ? '로그인 중...' :
               !user ? '구글로 로그인' : 
               !userProfile?.nickname ? '닉네임 설정' : 
               '채팅 시작하기'}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Chat;